module.exports = __webpack_public_path__ + "static/media/cognitive-data.7516aab6.svg";